import { LanguageKey, Storage } from "@/shared/common/enums";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface LanguageState {
  current: LanguageKey;
  isChanging: boolean;
}

const initialLanguage = (
  localStorage.getItem(Storage.Lang
  ) as LanguageKey) || LanguageKey.Hy;

const initialState: LanguageState = {
  current: initialLanguage,
  isChanging: false,
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setChangingLanguage(state, action: PayloadAction<boolean>) {
      state.isChanging = action.payload;
    },
    setLanguage(state, action: PayloadAction<LanguageKey>) {
      state.current = action.payload;
      localStorage.setItem(Storage.Lang, action.payload);
      document.documentElement.setAttribute("lang", action.payload);
    },
  },
});

export const { setLanguage, setChangingLanguage } = languageSlice.actions;
export default languageSlice.reducer;
